class PostMessageEmitter
{
    constructor(destinationWindow, destinationDomain)
    {
        this.destinationWindow = destinationWindow;
        this.destinationDomain = destinationDomain;
     //   if(!this.destinationWindow || !this.destinationDomain){
     //       throw "variable not clearly defined";
     //   }
    }

    send(destination, event, payload)
    {

        this.destinationWindow.postMessage({
            destination,
            event,
            payload
        }, this.destinationDomain)
    }
}

export default PostMessageEmitter;



// WEBPACK FOOTER //
// ./common/js/lib/PostMessageEmitter.js